import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => {
  return ({
    appBar: {
      width: "100vw",
      height: 64,
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      backgroundColor: "hsl(186.67deg 65.85% 8.04%)",
      color: "white",
      borderBottom: "1px solid #051819",
    },
    toolbar: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    logo: {
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
      height: 40,
    },
    grow: {
      flexGrow: 1,
    },
    titleSpace: {
      marginLeft: theme.spacing(10),
    },
    subTitle: {
      width: 120,
      color: theme.palette.text.hint,
      fontSize: 14,
      "&:hover": {
        cursor: "pointer",
        color: "#fff",
      },
      display: "flex",
      alignItems: "center",
    },
    gap: {
      // marginRight: theme.spacing(10),
    },
    headerMenu: {
      position: "absolute",
      left: 0,
      top: 64,
      width: "100%",
      backgroundColor: "#061f20",
      padding: theme.spacing(2),
      borderRadius: 0,
    },
    groupTitle: {
      color: theme.palette.text.primary,
      fontWeight: "bolder",
      fontSize: 16,
      paddingLeft: 0,
    },
    productTitle: {
      display: "flex",
      alignItems: "center",
      color: theme.palette.text.secondary,
      fontWeight: "bolder",
      fontSize: 14,
      paddingLeft: 0,
      "&:hover": {
        cursor: "pointer",
      },
      "& img": {
        width: 18,
        height: 18,
      }
    },
    productDesc: {
      color: theme.palette.text.secondary,
      fontSize: 12,
    },
    toolName: {
      display: "flex",
      alignItems: "center",
      textAlign: "center",
      color: theme.palette.text.primary,
      fontSize: 14,

      "&:hover": {
        cursor: "pointer",
        color: theme.palette.primary.main,
      },
      "& img": {
        width: 18,
        height: 18,
      },
      "& span": {
        backgroundColor: "#061f20",
        color: "#ffffff",
        fontSize: 12,
        fontWeight: 400,
      }
    },
    toolNameX: {
      display: "flex",
      alignItems: "center",
      textAlign: "center",
      color: theme.palette.text.hint,
      fontSize: 12,
      fontWeight: 600,
      "&:hover": {
        cursor: "not-allowed",
      },
      "& img": {
        width: 18,
        height: 18,
      }
    },
    mainTitle: {
      color: "#061f20",
      fontSize: 16,
      fontWeight: 800,
      marginBottom: theme.spacing(3),
    },
    visitButton: {
      "& span": {
        textTransform: "Capitalize",
      },
      backgroundColor: "#061f20",
      borderRadius: 0,
      color: "#ffffff",
      "&:hover": {
        backgroundColor: "#ffffff",
        color: "#061f20",
      }
    },
    glabOverviewGrid: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "32px 48px",
    },
    glabOverviewImg: {
      width: "80%",
    },
    glabSolutionImg: {
      marginTop: "20%",
      width: "60%",
    },
    divider: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      color: theme.palette.text.hint,
    },
    dividerApps: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    platformTag: {
      fontSize: 12,
      color: theme.palette.text.secondary,
    },
    solutionPart: {
      minHeight: "30vh",
      display: "flex",
      color: theme.palette.text.hint,
    },
    solutionName: {
      color: theme.palette.text.primary,
      fontWeight: 600,
      "&:hover": {
        cursor: "not-allowed",
      },
    },
    solutionDetail: {
      color: theme.palette.text.hint,
      fontSize: 12,
      paddingRight: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    solutionButton: {
      marginTop: theme.spacing(4),
      textTransform: "Capitalize",
      paddingLeft: 0,
      "&:hover": {
        "& svg": {
          marginLeft: theme.spacing(1),
        }
      }
    },
    buttonInfoToDocs: {
      marginLeft: theme.spacing(2),
      borderColor: theme.palette.text.hint,
      color: theme.palette.text.hint,
      "&:hover": {
        color: "white",
        borderColor: "white",
      },
      textTransform: "Capitalize",
    },
  });
});
